(() => {
  if (customElements.get('fp-shipping-progress')) return;
  class ShippingProgress extends HTMLElement {
    static get observedAttributes() { return ['subtotal', 'digital', 'country', 'currency']; }
    connectedCallback() { this.render(); }
    attributeChangedCallback() { if (this.isConnected) this.render(); }
    render() {
      const copy = this.querySelector('[data-shipping-copy]'), note = this.querySelector('[data-shipping-note]');
      if (!copy || !note) return;
      const raw = this.getAttribute('subtotal'), subtotal = Number(raw), digital = this.hasAttribute('digital');
      this.hidden = raw === null || raw === '' || !Number.isFinite(subtotal) || subtotal < 0;
      if (this.hidden) return;
      const eligibleMarket = this.getAttribute('country') === 'US' && this.getAttribute('currency') === 'USD';
      copy.replaceChildren();
      if (!eligibleMarket) {
        copy.textContent = digital ? 'Digital downloads require no shipping.' : 'Shipping is calculated at checkout.';
        note.textContent = ''; note.hidden = true; return;
      }
      const remaining = Math.max(0, 7500 - Math.round(subtotal));
      const strong = document.createElement('strong'); strong.textContent = 'FREE SHIPPING';
      if (remaining) {
        const money = document.createElement('strong');
        money.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: 'USD'}).format(remaining / 100);
        copy.append("You're only ", money, ' away from ', strong);
      } else copy.append("Congrats! You've earned ", strong);
      note.hidden = false;
      note.textContent = digital
        ? 'US physical delivery after dispatch: Standard 5–7 business days; Express 3–5 business days. Digital downloads require no shipping.'
        : 'US delivery after dispatch: Standard 5–7 business days; Express 3–5 business days. Free standard shipping eligibility after discounts is confirmed at checkout.';
    }
  }
  customElements.define('fp-shipping-progress', ShippingProgress);
})();
